import React   from "react";
import Cashout from '~/services/cashouts';


const CashoutCard = ({item})=> {
  return (
    <div className="currency-type-row" style={{backgroundColor: item.currencyBackground.colors[0]}}>
      <div className="left">
        <h6> {item.currencyName} ${item.amount} </h6>
        <p>  Points: {item.points} <br/> Redeemed: {new Date(item.createdAt).toLocaleDateString()} </p>
        <p>  Status: <strong> { Cashout.statusList[item.status].label } </strong> </p>
      </div>
      <div className="right">
        <img src={item.currencyIconSmall} />
      </div>
    </div>
  );
};

export default CashoutCard;
